<template>
  <div>
    <ul class="margin-left-xs">
      <li v-for="(item, i) in productSummaryBullets" :key="i">
        <button
          v-if="item.type === CUSTOM_POPUP"
          data-testid="custom-popup-button"
          class="link-body button-content"
          @click.prevent="openCustomPopup(item)"
          v-html="item.text"
        ></button>

        <a
          v-else-if="item.type === WARRANTY"
          :href="item.url"
          target="_blank"
          :data-link-type="item.type"
          data-testid="warranty-link"
          v-html="item.text"
        ></a>

        <a v-else-if="item.type === STATIC && isMcom" :href="item.url" target="_blank" data-testid="static-link-mcom" v-html="item.text"></a>
        <a
          v-else-if="item.type === STATIC && isBcom"
          data-testid="static-link-bcom"
          :href="item.url || '#'"
          :data-link-type="item.type"
          @click.prevent="openContent(item.fileName, item.width, item.height)"
          v-html="item.text"
        ></a>
        <a v-else-if="item.url" :href="item.url" :data-link-type="item.type" :data-testid="`${item.type}-url-link`" v-html="item.text"></a>

        <span v-else data-testid="other-type" v-html="item.text"></span>
      </li>
      <li v-if="isGiftCardTermsAvailable" data-testid="terms-and-conditions">
        <a
          href="https://www.bloomingdales.com/customer-service/articles/bloomingdales-e-gift-card-terms-conditions"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and conditions
        </a>
        are applied to gift certificates/gift cards.
      </li>
    </ul>
  </div>
</template>

<script setup>
import { defineAsyncComponent, markRaw } from 'vue';
import { pop } from '~/utils/popupWindow';
import { useBrand } from '~/composables/useBrand';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import { useProductDetails } from '../composables/useProductDetails';
import { useSlideout } from '~/composables/utils/useSlideout';

const CUSTOM_POPUP = 'CUSTOM_POPUP';
const WARRANTY = 'WARRANTY';
const STATIC = 'STATIC';

const props = defineProps({
  openAsInitialSlideout: {
    type: Boolean,
    default: true,
  },
});

const { isMcom, isBcom } = useBrand();
const { productSummaryBullets } = useProductDetails();
const { isEGiftCard } = useFeatureEligibility();
const { showSlideout, addSlideout } = useSlideout();

const isGiftCardTermsAvailable = isBcom && isEGiftCard;

/**
 * @param {BulletLinkPopup} item
 */
function openCustomPopup(item) {
  const config = {
    id: 'product-details-drawer',
    title: 'Product Details',
    props: { fileName: item.fileName },
    component: markRaw(
      defineAsyncComponent(
        /* istanbul ignore next */ () =>
          import(/* webpackChunkName: "ProductDetailsInfo" */ '../../../components/slideoutContent/ProductDetailsInfo.vue'),
      ),
    ),
    backable: !props.openAsInitialSlideout,
  };
  return props.openAsInitialSlideout ? showSlideout(config) : addSlideout(config);
}
/**
 * @param {string | undefined} fileName
 * @param {string | undefined} width
 * @param {string | undefined} height
 */
const openContent = (fileName, width, height) => {
  pop(fileName, 'spreePop', `resizable=yes,menubar,status,scrollbars=yes,width=${width}, height=${height}`);
};
</script>

<style lang="scss" scoped>
.button-content {
  width: 100%;
  text-align: left;
}
</style>
